import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import bgPatternImage from '@/images/bg_pattern_inverted.webp';
import { FaqAccordions } from './FaqAccordions';

export function Faq({
	titleProps = {},
	titleWrapperProps = {},
	container = true,
	bottomPattern = true,
	sx = {},
	...props
}) {
	const { t } = useTranslation();

	const content = (
		<>
			<Box
				textAlign="center"
				mb={{ xs: 1, md: 4 }}
				py={1}
				{...titleWrapperProps}
			>
				<Typography
					component="h2"
					fontSize={{ xs: 28, md: 40 }}
					lineHeight={{ xs: 1.3, md: 1.5 }}
					fontWeight={{ xs: 'regular', md: 'extraBold' }}
					{...titleProps}
				>
					{t('home.faq.title')}
				</Typography>
			</Box>

			<FaqAccordions container={container} />
		</>
	);

	return (
		<Box
			component="section"
			bgcolor="#FFF"
			pt={{ xs: 3, md: 6 }}
			pb={{ xs: 4, md: 24 }}
			sx={{
				...(bottomPattern
					? {
							backgroundImage: {
								xs: 'none',
								md: `url(${bgPatternImage})`
							},
							backgroundPosition: 'bottom',
							backgroundRepeat: 'repeat-x',
							backgroundSize: 'auto 250px'
						}
					: {}),

				...sx
			}}
			{...props}
		>
			{container ? <Container maxWidth="lg">{content}</Container> : content}
		</Box>
	);
}
